module.exports = __webpack_public_path__ + "img/product-page(full-page).9846092b.jpg";